import { useEffect, useState } from "react";
import crossIcon from "../../Assets/closeIcon.svg";

export const CompanyValuesInput = ({ selectedValues = [], setSelectedValues, values }) => {
    const uniqueValues = [...new Set(values)];
    const [showList, setShowList] = useState(false);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        setShowList(true);
    }, [inputValue]);

    const listToShow = uniqueValues
        ?.filter(item => 
            item?.toLowerCase()?.includes(inputValue?.toLowerCase()) &&
            !selectedValues.includes(item)
        )
        ?.slice(0, 1000);

    const needToShow = () => {
        if (listToShow.length === 0 || inputValue.length < 1) {
            return false;
        }
        return showList;
    };

    const handleAddValue = (value) => {
        if (selectedValues.length < 2 && !selectedValues.includes(value)) {
            setSelectedValues([...selectedValues, value]);
            setInputValue('');
            setShowList(false);
        }
    };

    const handleRemoveValue = (value) => {
        setSelectedValues(selectedValues.filter(item => item !== value));
        setInputValue('');
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && inputValue.trim()) {
            const exists = uniqueValues.some(item => 
                item.toLowerCase() === inputValue.trim().toLowerCase()
            );
            
            if (!exists && selectedValues.length < 2 && !selectedValues.includes(inputValue.trim())) {
                handleAddValue(inputValue.trim());
            }
        }
    };
    return (
        <div>
            <label className="block text-sm font-medium mb-2">Select your Non-negotiable Personal Values or Personal Beliefs (Add exactly 2) (Press ENTER after inputting each Value)</label>
            <div className='bg-white rounded-xl px-4 py-2 w-full border border-input-box-border border-solid flex flex-wrap items-center gap-2 relative'>
                {selectedValues?.map((item, index) => (
                    <div
                        key={index}
                        className='flex items-center gap-1 bg-gray-100 px-2 py-1 rounded-xl'
                    >
                        <span className='text-sm text-[#3A3A3A]'>{item}</span>
                        <img
                            onClick={() => handleRemoveValue(item)}
                            src={crossIcon}
                            className='w-[0.6rem] cursor-pointer'
                            alt="remove value"
                        />
                    </div>
                ))}
                {selectedValues.length < 2 && (
                    <input
                        className='flex-grow outline-none text-sm placeholder:text-placeholder_color border-input-box-border px-2'
                        placeholder={selectedValues?.length === 0 ? 'e.g. Integrity, Ethics, Teamwork, Innovation' : ''}
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                )}
                {needToShow() && (
                    <ul className='absolute bottom-[110%] bg-white max-h-72 overflow-auto w-full p-2 border-[2px] border-gray-500 rounded-lg left-0 right-0 mt-1 z-10'>
                        {listToShow?.map((item, index) => (
                            <li
                                className='cursor-pointer hover:bg-gray-100 p-[.4rem]'
                                onClick={() => handleAddValue(item)}
                                key={index}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <p className='text-xs text-gray-500 mt-1'>{selectedValues.length}/2 selected</p>
        </div>
    );
};
